import type { Step } from 'react-joyride'

/**
 * Tour step definitions for the Song Settings guided tour
 *
 * Targets data-tour attributes on key elements to guide users through:
 * - Foundation tab (questions, POV)
 * - Boxes tab (creation, management)
 * - Structure, Sound, Style tabs
 * - AI tab
 * - Help sidebar itself
 */
export const TOUR_STEPS: Step[] = [
  {
    target: '[data-tour="tab-foundation"]',
    content: 'Start here! Foundation settings establish your song\'s narrative identity.',
    placement: 'bottom',
    disableBeacon: true,
    title: 'Foundation Tab'
  },
  {
    target: '[data-tour="core-questions"]',
    content: 'These three questions (Who/Whom/Why) provide clarity for your entire song. Answer them first!',
    placement: 'right',
    title: 'Core Questions'
  },
  {
    target: '[data-tour="pov-presets"]',
    content: 'Choose a point of view. Like film shots, each creates a different intimacy level with your listener.',
    placement: 'left',
    title: 'Point of View'
  },
  {
    target: '[data-tour="tab-boxes"]',
    content: 'Boxes help you map the emotional and narrative beats of your song. Most songs have 3-5 key moments.',
    placement: 'bottom',
    title: 'Boxes Tab'
  },
  {
    target: '[data-tour="add-box-button"]',
    content: 'Add up to 5 boxes to outline key moments or turning points in your song.',
    placement: 'top',
    title: 'Adding Boxes'
  },
  {
    target: '[data-tour="tab-structure"]',
    content: 'Define your song\'s sections (Verse, Chorus, Bridge) and their order.',
    placement: 'bottom',
    title: 'Structure Tab'
  },
  {
    target: '[data-tour="tab-sound"]',
    content: 'Configure rhyme schemes and prosody settings to shape how your lyrics sound.',
    placement: 'bottom',
    title: 'Sound Tab'
  },
  {
    target: '[data-tour="tab-style"]',
    content: 'Set keywords and style preferences to maintain thematic consistency.',
    placement: 'bottom',
    title: 'Style Tab'
  },
  {
    target: '[data-tour="tab-ai"]',
    content: 'Configure AI assistance behavior—how creative, how involved, and what to preserve.',
    placement: 'bottom',
    title: 'AI Tab'
  },
  {
    target: '[data-tour="help-sidebar"]',
    content: 'Quick tips and keyboard shortcuts are always available here. Press ⌘H to toggle this sidebar!',
    placement: 'left',
    title: 'Help Sidebar'
  }
]

// Local storage key for tour completion tracking
export const TOUR_COMPLETED_KEY = 'settings-tour-completed'
